import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";

const Footer = () => {
  return(
    <Box bottom={0} position='relative'>
      <Stack>
        {/* <Typography>designed by Silver-Torus</Typography> */}
      </Stack>
    </Box>
  );
};


export default Footer;